const formatLogString = (
  handler: string,
  scope: string,
  str: string,
  totalDurationMS: number
): string => `[${handler}] ${scope} | ${str} [${totalDurationMS}ms]`

export default formatLogString
